import { SelectChangeEvent, Select, MenuItem, FormControl } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { useOrganization } from '@/contexts/OrganizationContext'

const ORG_SCOPED_PREFIXES = ['/teammates', '/teams', '/user-tools']

export default function OrgPicker() {
  const { organizations, currentOrganizationId, setCurrentOrganizationId } = useOrganization()
  const navigate = useNavigate()
  const location = useLocation()

  if (organizations.length < 2) return null

  const handleChange = (event: SelectChangeEvent) => {
    const newOrgId = event.target.value
    setCurrentOrganizationId(newOrgId)
    const matchedPrefix = ORG_SCOPED_PREFIXES.find(prefix => location.pathname.startsWith(prefix))
    if (matchedPrefix && location.pathname !== matchedPrefix) {
      navigate(matchedPrefix)
    }
  }

  return (
    <FormControl id="org_picker__container" size="small" sx={{ width: '240px' }}>
      <Select
        value={currentOrganizationId ?? ''}
        onChange={handleChange}
        displayEmpty
        renderValue={value => {
          const org = organizations.find(o => o.organization_id === value)
          return (
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>
              {org?.organization_name ?? 'No org found'}
            </span>
          )
        }}
      >
        {organizations.map(org => (
          <MenuItem key={org.organization_id} value={org.organization_id}>
            {org.organization_name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
